export const useResponsiveFontSize = () => {
    let flag = false

    const initFontSize = () => {
        const viewWidth = document.documentElement.clientWidth
        // 获取屏幕分辨率的宽 / 10
        // 1REM = 10px
        document.documentElement.style.fontSize = viewWidth / 39 + 'px'
    }

    const onWindowResize = () => {
        if (!flag) {
            flag = true
            setTimeout(() => {
                initFontSize()
                flag = false
            }, 100)
        }
    }

    const init = () => {
        initFontSize()
        window.addEventListener('resize', onWindowResize)
    }

    const destroy = () => {
        window.removeEventListener('resize', onWindowResize)
    }

    return {
        init,
        destroy
    }
}